const breakPoints = {
  small: 575,
  medium: 900,
};

export default breakPoints;
